var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWithRmNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.896 8.39746L15.896 10.2288",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8945 6.17452C15.8026 6.17452 15.7281 6.09936 15.7281 6.00666C15.7281 5.91395 15.8026 5.83881 15.8945 5.83881",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8975 6.17452C15.9894 6.17452 16.0639 6.09936 16.0639 6.00666C16.0639 5.91395 15.9894 5.83881 15.8975 5.83881",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75037 19.8738H19.8746",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.271 11.7704C5.271 12.4609 5.54532 13.1232 6.03363 13.6115C6.52194 14.0998 7.18423 14.3742 7.8748 14.3742C8.56537 14.3742 9.22765 14.0998 9.71596 13.6115C10.2043 13.1232 10.4786 12.4609 10.4786 11.7704C10.4786 11.0798 10.2043 10.4175 9.71596 9.9292C9.22765 9.44089 8.56537 9.16656 7.8748 9.16656C7.18423 9.16656 6.52194 9.44089 6.03363 9.9292C5.54532 10.4175 5.271 11.0798 5.271 11.7704Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74878 19.876V18.5007C3.74878 16.2222 5.59589 14.3751 7.87444 14.3751C10.153 14.3751 12.0001 16.2222 12.0001 18.5007V19.876",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5285 11.6185C13.3891 12.4617 14.5677 12.9815 15.8677 12.9815C18.5033 12.9815 20.6399 10.845 20.6399 8.20941C20.6399 5.57385 18.5033 3.43732 15.8677 3.43732C13.312 3.43732 11.2255 5.44644 11.1014 7.97143",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithRmNewSelected);
export default __webpack_public_path__ + "static/media/ChatWithRMNewSelected.6da49ac9d7bd4890d3e13833844d4518.svg";
export { ForwardRef as ReactComponent };